import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { SPACING } from "~/styles/variables";

type ConfirmArchiveTemplateModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isArchiving: boolean;
  isSystemTemplate?: boolean;
};

export const ConfirmArchiveTemplateModal = ({
  isOpen,
  onClose,
  onConfirm,
  isArchiving,
  isSystemTemplate,
}: ConfirmArchiveTemplateModalProps) => (
  <ModalV2
    show={isOpen}
    onHide={onClose}
    title="Archive template"
    size="small"
    visuallyHideTitle
    data-testid="confirm-archive-template-modal"
  >
    <ModalV2.Body>
      <Flex flexDirection="column" alignItems="center" gap={SPACING.MEDIUM}>
        <Icon type="exclamation-triangle" size="xx-large" variant="outline" />
        <Text variant="strong-xl">
          Template will no longer be {isSystemTemplate ? "available" : "usable"}
        </Text>
        <Text variant="secondary-md" align="center">
          {isSystemTemplate
            ? "Users won't be able to reference or duplicate this system template."
            : "Users will no longer be able to run reports from this template."}
        </Text>
      </Flex>
    </ModalV2.Body>
    <ModalV2.Footer>
      <Flex flexDirection="column" gap={SPACING.SMALL}>
        <Button
          variant="danger"
          onClick={onConfirm}
          isLoading={isArchiving}
          disabled={isArchiving}
          isFullWidth
          data-testid="confirm-archive-template-button"
        >
          Archive template
        </Button>
        <Button variant="neutral" onClick={onClose} disabled={isArchiving} isFullWidth>
          Back
        </Button>
      </Flex>
    </ModalV2.Footer>
  </ModalV2>
);
